<!-- @veltra/icons generated sha256:df7559b50c9287ca gen:8 source:src/svg/normal/time.svg -->
<script setup lang="ts">
defineOptions({ name: 'UTime' })
</script>
<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
    <path
      fill="currentColor"
      fill-rule="evenodd"
      d="M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14M8 2a6 6 0 1 1 0 12A6 6 0 0 1 8 2m-.5 6.193V4.5a.501.501 0 0 1 1-.001v3.279c0 .128.052.252.14.345l1.729 1.815a.505.505 0 0 1-.005.699.5.5 0 0 1-.716-.004l-2.01-2.1a.5.5 0 0 1-.138-.339"
    />
  </svg>
</template>
